import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Avalie a Qualidade da ligação", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " De uma nota abaixo baseado na qualidade do áudio e vídeo que durante a sessão. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Teve algum problema?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Caso teve algum problema ou deseja relatar alguma ocorrência, descreva abaixo: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VotingStars = _resolveComponent("VotingStars")!
  const _component_TextAreaInput = _resolveComponent("TextAreaInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    id: "appointment_rating_pending",
    title: "Como foi sua sessão?",
    onModalClosed: _ctx.handleFinish
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_VotingStars, {
        size: "fa-xl",
        onOnClick: _cache[0] || (_cache[0] = (rating) => _ctx.setRating(rating))
      }),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_TextAreaInput, {
        model: _ctx.v$.form.description
      }, null, 8, ["model"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Pular",
        onOnClick: _ctx.handleFinish,
        outline: ""
      }, null, 8, ["onOnClick"]),
      _createVNode(_component_Button, {
        label: "Enviar avaliação",
        onOnClick: _ctx.submitRating,
        loading: _ctx.submitting
      }, null, 8, ["onOnClick", "loading"])
    ]),
    _: 1
  }, 8, ["onModalClosed"]))
}